import {Component, HostListener, Inject, OnInit, ViewChild} from '@angular/core';
import {CoreSettings, RuntimeContext, SETTINGS, StyleService, ThemeService, UiConfigService} from '@lv1871/core';
import {ShellConfigService} from '../../../lib-dialog-toolbox/services/shell-config.service';
import {AntragComponent} from '../../../lib-dialog-toolbox/components/antrag/antrag.component';
import {take} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {EventService} from '../../../lib-dialog-toolbox';

@Component({
    selector: 'lv-antragsannahme',
    templateUrl: './antragsannahme.component.html',
    styleUrls: ['./antragsannahme.component.scss'],
    standalone: false
})
export class AntragsannahmeComponent implements OnInit {

  @ViewChild('antrag')
  public antrag: AntragComponent;

  public isThemeAvailable: boolean = false;
  public environment: string;
  private _showUnloadDialog = true;
  private _subscription = Subscription.EMPTY;

  constructor(private _uiConfigService: UiConfigService, private _themeService: ThemeService, private _eventService: EventService,
              public shellConfigService: ShellConfigService, private _styleService: StyleService,
              @Inject(SETTINGS) public settings: CoreSettings) {
  }
  @HostListener('window:beforeunload', ['$event'])
  public onBeforeUnload(event) {
    if (!this.shellConfigService.getParameter().runtimeContext ||
        this.shellConfigService.getParameter().runtimeContext === RuntimeContext.SB_SHELL) {
      return null;
    }
    if (this._showUnloadDialog === true) {
      return false;
    } else {
      return null;
    }
  }

  ngOnInit(): void {
    this.environment = this._uiConfigService.settings.environment.name;
    this._styleService.loadStyles().pipe(take(1)).subscribe(res => {

      this._themeService.setApplicationTheme(
          this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-primary'),
          this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-secondary'),
          this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-warn'),
          'lv-app-antrag'
      );
      this.isThemeAvailable = true;
    });
    this._subscription = this._eventService.supressBeforeUnloadDialogButtonClicked$.subscribe(_ => {
          this._showUnloadDialog = false;
        }
    );
  }

  public reinit() {
    this.antrag.isLoading = true;
    this.antrag.init();
  }
}
